import styled from 'styled-components';
import { colors } from 'styles/colors';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

// Sub-tabs (Operação / Gestão de Ativos) — manter comentado até Operação existir.
// export const SubTabsWrapper = styled.div`
//   padding-top: 10px;
// `;
//
// export const HeaderRow = styled.div`
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
//   gap: 16px;
//   flex-wrap: wrap;
// `;

// Wrapper antigo do <Filter /> da Visão Geral; substituído por MaintenanceHeader.
// export const FilterContainer = styled.div`
//   position: relative;
//   display: flex;
//   gap: 16px;
//   align-items: center;
//   justify-content: flex-start;
//   margin-top: -20px;
// `;

export const HeaderBar = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const HeaderTopRow = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  flex-wrap: wrap;
`;

export const FilterButtonSlot = styled.div<{ disabled?: boolean }>(
  ({ disabled }) => `
  > div {
    background: transparent;
    margin: 0;
    padding: 0;
    border-bottom: 0;
  }
  ${disabled ? `
    filter: grayscale(1);
    opacity: 0.5;
    pointer-events: none;
  ` : ''}
`,
);

export const FieldsRow = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(182px, 1fr));
  gap: 8px;
  align-items: center;
  width: 100%;
  padding: 8px 16px;
  background: ${colors.bg['weak-100']};
  border-top: 1px solid ${colors.stroke['sub-300']};
  border-bottom: 1px solid ${colors.stroke['sub-300']};

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const ViewByGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
`;

export const ViewByLabel = styled.span<{ disabled?: boolean }>(
  ({ disabled }) => `
  font-weight: 600;
  font-size: 12px;
  color: ${disabled ? colors.text['soft-400'] : colors.text['primary-base']};
`,
);

export const ViewByOption = styled.button<{ selected: boolean; disabled?: boolean }>(
  ({ selected, disabled }) => `
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 8px;
  color: ${disabled ? colors.text['soft-400'] : (selected ? colors.text['primary-base'] : colors.text['sub-500'])};

  &:hover {
    background: ${colors.bg['weak-100']};
  }

  &:disabled {
    cursor: not-allowed;
  }

  &:disabled:hover {
    background: transparent;
  }
`,
);

export const RadioOuter = styled.span<{ selected: boolean; disabled?: boolean }>(
  ({ selected, disabled }) => {
    const borderColor = disabled
      ? colors.stroke['soft-200']
      : (selected ? colors.stroke['primary-base'] : colors.stroke['sub-300']);
    return `
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    border: 1.5px solid ${borderColor};
    background: ${colors.bg['white-0']};
    flex-shrink: 0;
  `;
  },
);

export const RadioInner = styled.span<{ disabled?: boolean }>(
  ({ disabled }) => `
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: ${disabled ? colors.bg['soft-200'] : colors.bg['primary-base']};
`,
);

export const ViewByIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  color: currentcolor;
`;

export const ViewByText = styled.span`
  font-size: 13px;
  font-weight: 500;
`;
